import React from 'react';
import BaseRouter from '@components/Routers/BaseRouter';

function App() {
  return <BaseRouter />;
}

export default App;
